import { render, staticRenderFns } from "./CartPill.vue?vue&type=template&id=463b26cf&scoped=true&"
import script from "./CartPill.vue?vue&type=script&lang=js&"
export * from "./CartPill.vue?vue&type=script&lang=js&"
import style0 from "./CartPill.vue?vue&type=style&index=0&id=463b26cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b26cf",
  null
  
)

export default component.exports